"use strict";
/**
 * Utility script for managing items and item drops
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeItem = exports.spawnItem = exports.spawnDrops = void 0;
var pixi_js_1 = require("pixi.js");
var app_1 = require("../../app");
var rxjs_1 = require("rxjs");
var helpers_1 = require("../../helpers");
var items_1 = require("../../data/items");
var itemCount = 0;
var despawnTickCount = 75;
var flashTickCount = 50;
var rollForLoot = function (dropTable) {
    var _a, _b, _c, _d;
    // common is 50% 
    // rare is 5%
    // legendary is 0.5%
    var drops = ((_a = dropTable.always) === null || _a === void 0 ? void 0 : _a.length) > 0 ? __spreadArray([], dropTable.always, true) : [];
    var roll = Math.random() * 100;
    if (((_b = dropTable.legendary) === null || _b === void 0 ? void 0 : _b.length) > 0 && roll >= 99.5) {
        drops.push((0, helpers_1.getRandomElement)(dropTable.legendary));
    }
    else if (((_c = dropTable.rare) === null || _c === void 0 ? void 0 : _c.length) > 0 && roll >= 95) {
        drops.push((0, helpers_1.getRandomElement)(dropTable.rare));
    }
    else if (((_d = dropTable.common) === null || _d === void 0 ? void 0 : _d.length) > 0 && roll >= 50) {
        drops.push((0, helpers_1.getRandomElement)(dropTable.common));
    }
    return drops;
};
var spawnDrops = function (position, dropTable) {
    var drops = rollForLoot(dropTable);
    if (drops.length === 0)
        return;
    drops.forEach(function (drop) {
        (0, exports.spawnItem)(drop, position);
    });
};
exports.spawnDrops = spawnDrops;
var spawnItem = function (name, _a, ticksToDespawn) {
    var x = _a.x, y = _a.y;
    if (ticksToDespawn === void 0) { ticksToDespawn = 75; }
    var item = items_1.itemData[name];
    if (!item) {
        console.error("".concat(name, " is not a valid item."));
        return;
    }
    var gameTicks$ = app_1.appService.gameTicks$, spriteContainer = app_1.appService.spriteContainer;
    itemCount++;
    var sprite = pixi_js_1.Sprite.from(item.url);
    sprite.width = item.width;
    sprite.height = item.height;
    sprite.anchor.set(0.5);
    sprite.position.set(x, y);
    spriteContainer.addChild(sprite);
    if (!app_1.gameState.items[item.type]) {
        app_1.gameState.items[item.type] = [];
    }
    var id = "".concat(name, "-").concat(itemCount);
    app_1.gameState.items[item.type].push({ name: name, id: id, sprite: sprite, stats: item.stats });
    if (ticksToDespawn > 0) {
        gameTicks$
            .pipe((0, rxjs_1.take)(despawnTickCount))
            .subscribe(function (tickCount) {
            if (tickCount < flashTickCount)
                return;
            sprite.alpha = sprite.alpha === 1 ? 0.5 : 1;
        }, null, function () { return (0, exports.removeItem)(name, { id: id, sprite: sprite, method: "despawn" }); });
    }
};
exports.spawnItem = spawnItem;
var removeItem = function (type, _a) {
    var id = _a.id, sprite = _a.sprite, method = _a.method;
    if (sprite.destroyed)
        return;
    if (type === "bones" && method === "despawn") {
        app_1.gameState.incrementBonesDespawned();
    }
    try {
        sprite.destroy();
        // TODO: if multiple bones are being removed at once we can be more efficient
        app_1.gameState.items[type] = __spreadArray([], app_1.gameState.items[type].filter(function (i) { return i.id !== id; }), true);
    }
    catch (e) {
        console.error(e);
    }
};
exports.removeItem = removeItem;
